import { render, staticRenderFns } from "./teachers-lessons.vue?vue&type=template&id=3af24050&"
import script from "./teachers-lessons.vue?vue&type=script&lang=js&"
export * from "./teachers-lessons.vue?vue&type=script&lang=js&"
import style0 from "./teachers-lessons.vue?vue&type=style&index=0&id=3af24050&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports